export const FIFA_TEAM_MEMBERS = {
  WYintcWb: [{name: 'Бейло Юстин', number: 13, type: 'Вратари'}, {
    name: 'Нопперт Андриес',
    number: 23,
    type: 'Вратари'
  }, {name: 'Пасвер Ремко', number: 1, type: 'Вратари'}, {
    name: 'Аке Натан',
    number: 5,
    type: 'Защитники'
  }, {name: 'Ван Дейк Вирджил', number: 4, type: 'Защитники'}, {
    name: 'Дамфрис Дензел',
    number: 22,
    type: 'Защитники'
  }, {name: 'Де Врей Стефан', number: 6, type: 'Защитники'}, {
    name: 'Де Лигт Маттейс',
    number: 3,
    type: 'Защитники'
  }, {name: 'Маласия Тирелл', number: 16, type: 'Защитники'}, {
    name: 'Тимбер Юрриен',
    number: 2,
    type: 'Защитники'
  }, {name: 'Фримпонг Джереми', number: 26, type: 'Защитники'}, {
    name: 'Бергвейн Стивен',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Бергейс Стивен', number: 11, type: 'Полузащитники'}, {
    name: 'Блинд Дэйли',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Де Йонг Френки', number: 21, type: 'Полузащитники'}, {
    name: 'Де Рон Мартен',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Классен Дэви', number: 14, type: 'Полузащитники'}, {
    name: 'Копмейнерс Тён',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Ланг Ноа', number: 12, type: 'Полузащитники'}, {
    name: 'Симонс Хави',
    number: 25,
    type: 'Полузащитники'
  }, {name: 'Тейлор Кеннет', number: 24, type: 'Полузащитники'}, {
    name: 'Вегхорст Ваут',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Гакпо Коди', number: 8, type: 'Нападающие'}, {
    name: 'Де Йонг Люк',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Депай Мемфис', number: 10, type: 'Нападающие'}, {
    name: 'Янссен Винсент',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Ван Гал Луи', type: 'Тренер'}],
  hOIsJLJr: [{name: 'Гомис Альфред', number: 23, type: 'Вратари'}, {
    name: 'Дьенг Сени',
    number: 1,
    type: 'Вратари'
  }, {name: 'Менди Эдуар', number: 16, type: 'Вратари'}, {
    name: 'Балло-Туре Фоде',
    number: 2,
    type: 'Защитники'
  }, {name: 'Диалло Абду', number: 22, type: 'Защитники'}, {
    name: 'Кулибали Калиду',
    number: 3,
    type: 'Защитники'
  }, {name: 'Менди Формозе', number: 14, type: 'Защитники'}, {
    name: 'Н\'Диайе Мусса',
    number: 5,
    type: 'Защитники'
  }, {name: 'Сабали Юссуф', number: 12, type: 'Защитники'}, {
    name: 'Сисс Пате',
    number: 11,
    type: 'Защитники'
  }, {name: 'Сиссе Папе Абу', number: 4, type: 'Защитники'}, {
    name: 'Гуйе Идрисса',
    number: 5,
    type: 'Полузащитники'
  }, {name: 'Гуйе Папе', number: 26, type: 'Полузащитники'}, {
    name: 'Джексон Николас',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Куяте Шейх', number: 8, type: 'Полузащитники'}, {
    name: 'Лум Мамаду',
    number: 22,
    type: 'Полузащитники'
  }, {name: 'Менди Нампалис', number: 6, type: 'Полузащитники'}, {
    name: 'Наме Мустафа',
    number: 25,
    type: 'Полузащитники'
  }, {name: 'Ндиайе Илиман', number: 29, type: 'Полузащитники'}, {
    name: 'Сарр Папе',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Якобс Исмаил', number: 13, type: 'Полузащитники'}, {
    name: 'Диа Булайе',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Диатта Крепин', number: 15, type: 'Нападающие'}, {
    name: 'Дьеду Фамара',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Дьенг Бамба', number: 20, type: 'Нападающие'}, {
    name: 'Сарр Исмаила',
    number: 23,
    type: 'Нападающие'
  }, {name: 'Сиссе Алью', type: 'Тренер'}],
  '8tbm8Tri': [{name: 'Галиндес Эрнан', number: 1, type: 'Вратари'}, {
    name: 'Домингес Александр',
    number: 22,
    type: 'Вратари'
  }, {name: 'Рамирес Мойзес', number: 12, type: 'Вратари'}, {
    name: 'Арреага Хавьер',
    number: 14,
    type: 'Защитники'
  }, {name: 'Пако Уильям', number: 24, type: 'Защитники'}, {
    name: 'Паласиос Диего',
    number: 6,
    type: 'Защитники'
  }, {name: 'Поросо Джексон', number: 25, type: 'Защитники'}, {
    name: 'Пресиадо Анхело',
    number: 17,
    type: 'Защитники'
  }, {name: 'Роберт Арболеда', number: 4, type: 'Защитники'}, {
    name: 'Торрес Феликс',
    number: null,
    type: 'Защитники'
  }, {name: 'Хинкапи Пьеро', number: 3, type: 'Защитники'}, {
    name: 'Эступинан Первис',
    number: 7,
    type: 'Защитники'
  }, {name: 'Ibarra Romario', number: 10, type: 'Полузащитники'}, {
    name: 'Груэсо Карлос',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Дельгадо Patrickson', number: 15, type: 'Полузащитники'}, {
    name: 'Кайседо Мойзес',
    number: 23,
    type: 'Полузащитники'
  }, {name: 'Мена Анхель', number: 15, type: 'Полузащитники'}, {
    name: 'Мендес Жегсон',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Родригес Кевин', number: 26, type: 'Полузащитники'}, {
    name: 'Сармиенто Джереми',
    number: 16,
    type: 'Полузащитники'
  }, {name: 'Сифуентес Хосе', number: 5, type: 'Полузащитники'}, {
    name: 'Франко Алан',
    number: 21,
    type: 'Полузащитники'
  }, {name: 'Валенсия Эннер', number: 13, type: 'Нападающие'}, {
    name: 'Плата Гонсало',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Пресьядо Эдуар', number: 18, type: 'Нападающие'}, {
    name: 'Реаско Джоркаефф',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Эстрада Микаэль', number: 11, type: 'Нападающие'}, {name: 'Альфаро Густаво', type: 'Тренер'}],
  zqzHL77i: [{name: 'Баршам Мешал', number: 22, type: 'Вратари'}, {
    name: 'Хассан Юсеф',
    number: 21,
    type: 'Вратари'
  }, {name: 'аль-Шиб Саад', number: 1, type: 'Вратари'}, {
    name: 'Абдулсаллам Яссем',
    number: 15,
    type: 'Защитники'
  }, {name: 'Ассадалла Али', number: 8, type: 'Защитники'}, {
    name: 'Ахмед Хомам',
    number: 14,
    type: 'Защитники'
  }, {name: 'Мадибо Ассим', number: 23, type: 'Защитники'}, {
    name: 'Педро Мигель',
    number: 2,
    type: 'Защитники'
  }, {name: 'Хассан Абделькарим', number: 3, type: 'Защитники'}, {
    name: 'Хедер Musab',
    number: 13,
    type: 'Защитники'
  }, {name: 'Хухи Буалем', number: 16, type: 'Защитники'}, {
    name: 'аль-Рави Бассам',
    number: 15,
    type: 'Защитники'
  }, {name: 'аль-Хаджри Салем', number: 20, type: 'Защитники'}, {
    name: 'Будиаф Карим',
    number: 12,
    type: 'Полузащитники'
  }, {name: 'Ваад Мохаммед', number: 4, type: 'Полузащитники'}, {
    name: 'Мешаль Мустафа',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Мунтари Мохаммед', number: 9, type: 'Полузащитники'}, {
    name: 'Тарек Тарек',
    number: 5,
    type: 'Полузащитники'
  }, {name: 'Хатим Абдулазиз', number: 6, type: 'Полузащитники'}, {
    name: 'аль-Хадрами Наиф',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'аль-Хайдос Хасан', number: 10, type: 'Полузащитники'}, {
    name: 'Alaaeldin Ahmed',
    number: 7,
    type: 'Нападающие'
  }, {name: 'Альмоэс Али', number: 19, type: 'Нападающие'}, {
    name: 'Афиф Акрам',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Мазид Халид Мунир', number: 18, type: 'Нападающие'}, {
    name: 'Мохаммад Исмаил',
    number: 17,
    type: 'Нападающие'
  }, {name: 'Санчес Бас Феликс', type: 'Тренер'}],
  j9N9ZNFA: [{name: 'Пикфорд Джордан', number: 1, type: 'Вратари'}, {
    name: 'Поп Ник',
    number: 13,
    type: 'Вратари'
  }, {name: 'Рамсдейл Аарон', number: 23, type: 'Вратари'}, {
    name: 'Александр-Арнольд Трент',
    number: 18,
    type: 'Защитники'
  }, {name: 'Коуди Конор', number: 16, type: 'Защитники'}, {
    name: 'Магуайр Хари',
    number: 6,
    type: 'Защитники'
  }, {name: 'Стоунз Джон', number: 5, type: 'Защитники'}, {
    name: 'Триппьер Киран',
    number: 12,
    type: 'Защитники'
  }, {name: 'Уайт Бен', number: 21, type: 'Защитники'}, {
    name: 'Уокер Кайл',
    number: 2,
    type: 'Защитники'
  }, {name: 'Шоу Люк', number: 3, type: 'Защитники'}, {
    name: 'Беллингхем Джуд',
    number: 22,
    type: 'Полузащитники'
  }, {name: 'Галлахер Конор', number: 26, type: 'Полузащитники'}, {
    name: 'Грилиш Джек',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Дайер Эрик', number: 15, type: 'Полузащитники'}, {
    name: 'Маунт Мэйсон',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Мэддисон Джеймс', number: 25, type: 'Полузащитники'}, {
    name: 'Райс Деклан',
    number: 4,
    type: 'Полузащитники'
  }, {name: 'Сака Букайо', number: 17, type: 'Полузащитники'}, {
    name: 'Филлипс Калвин',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Фоден Фил', number: 20, type: 'Полузащитники'}, {
    name: 'Хендерсон Джордан',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Кейн Харри', number: 9, type: 'Нападающие'}, {
    name: 'Рэшфорд Маркус',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Стерлинг Рахим', number: 10, type: 'Нападающие'}, {
    name: 'Уилсон Каллам',
    number: 24,
    type: 'Нападающие'
  }, {name: 'Саутгейт Гарет', type: 'Тренер'}],
  fuitL4CF: [{name: 'Джонсон Шон', number: 25, type: 'Вратари'}, {
    name: 'Тернер Мэтт',
    number: 1,
    type: 'Вратари'
  }, {name: 'Хорват Этан', number: 34, type: 'Вратари'}, {
    name: 'Адамс Тайлер',
    number: 4,
    type: 'Защитники'
  }, {name: 'Дест Серджино', number: 2, type: 'Защитники'}, {
    name: 'Йедлин Деандре',
    number: 22,
    type: 'Защитники'
  }, {name: 'Картер-Викерс Кэмерон', number: 20, type: 'Защитники'}, {
    name: 'Мур Шакил',
    number: 18,
    type: 'Защитники'
  }, {name: 'Рим Тим', number: 13, type: 'Защитники'}, {
    name: 'Робинсон Энтони',
    number: 5,
    type: 'Защитники'
  }, {name: 'Скалли Джо', number: 26, type: 'Защитники'}, {
    name: 'Циммерман Уокер',
    number: 3,
    type: 'Защитники'
  }, {name: 'Акоста Келлин', number: 23, type: 'Полузащитники'}, {
    name: 'Лонг Аарон',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Маккенни Вестон', number: 8, type: 'Полузащитники'}, {
    name: 'Мусах Юнус',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Пулишич Кристиан', number: 10, type: 'Полузащитники'}, {
    name: 'Рейна Джованни',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Рольдан Кристиан', number: 17, type: 'Полузащитники'}, {
    name: 'Эронсон Бренден',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'де ла Торре Лука', number: 14, type: 'Полузащитники'}, {
    name: 'Веа Тимоти',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Моррис Джордан', number: 16, type: 'Нападающие'}, {
    name: 'Райт Хаджи Райт',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Сарджент Джошуа', number: 24, type: 'Нападающие'}, {
    name: 'Феррейра Хесус',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Берхальтер Грегг', type: 'Тренер'}],
  xrRx85iA: [{name: 'Абедзаде Амир', number: 1, type: 'Вратари'}, {
    name: 'Бейранванд Алиреза',
    number: 1,
    type: 'Вратари'
  }, {name: 'Ниазманд Пайям', number: 12, type: 'Вратари'}, {
    name: 'Хосейни Хоссейн',
    number: 24,
    type: 'Вратари'
  }, {name: 'Джалали Аболфази', number: 25, type: 'Защитники'}, {
    name: 'Канаани Хоссейн',
    number: 6,
    type: 'Защитники'
  }, {name: 'Мохаммади Милад', number: 5, type: 'Защитники'}, {
    name: 'Резаян Рамин',
    number: 23,
    type: 'Защитники'
  }, {name: 'Халилзаде Шоджа', number: 4, type: 'Защитники'}, {
    name: 'Хоссейни Маджид',
    number: 19,
    type: 'Защитники'
  }, {name: 'Чешми Рузбех', number: 15, type: 'Защитники'}, {
    name: 'Амири Вахид',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'Годдос Саман', number: 14, type: 'Полузащитники'}, {
    name: 'Голизаде Али',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Карими Али', number: 18, type: 'Полузащитники'}, {
    name: 'Мохаррами Садег',
    number: 2,
    type: 'Полузащитники'
  }, {name: 'Нуроллахи Ахмад', number: 7, type: 'Полузащитники'}, {
    name: 'Пуралиганджи Мортеза',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Сарлак Милад', number: 10, type: 'Полузащитники'}, {
    name: 'Тораби Мехди',
    number: 16,
    type: 'Полузащитники'
  }, {name: 'Хаджсафи Эхсан', number: 28, type: 'Полузащитники'}, {
    name: 'Эззатоллахи Сеид',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Азмун Сердар', number: 20, type: 'Нападающие'}, {
    name: 'Ансарифард Карим',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Джаханбахш Алиреза', number: 7, type: 'Нападающие'}, {
    name: 'Тареми Мехди',
    number: 9,
    type: 'Нападающие'
  }],
  YcUP0Nqp: [{name: 'Дэвис Адам', number: 1, type: 'Вратари'}, {
    name: 'Уорд Данни',
    number: 12,
    type: 'Вратари'
  }, {name: 'Хеннесси Уэйн', number: 1, type: 'Вратари'}, {
    name: 'Ампаду Итан',
    number: 15,
    type: 'Защитники'
  }, {name: 'Гантер Кристофер', number: 2, type: 'Защитники'}, {
    name: 'Дэвис Бен',
    number: 4,
    type: 'Защитники'
  }, {name: 'Кабанго Бенджамин', number: 5, type: 'Защитники'}, {
    name: 'Локьер Том',
    number: 4,
    type: 'Защитники'
  }, {name: 'Мефам Крис', number: 5, type: 'Защитники'}, {
    name: 'Робертс Коннор',
    number: 14,
    type: 'Защитники'
  }, {name: 'Родон Джо', number: 6, type: 'Защитники'}, {
    name: 'Уильямс Неко',
    number: 3,
    type: 'Защитники'
  }, {name: 'Аллен Джо', number: 7, type: 'Полузащитники'}, {
    name: 'Джеймс Дэниел',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Колвилл Рубин', number: 27, type: 'Полузащитники'}, {
    name: 'Льюитт Дилан',
    number: 23,
    type: 'Полузащитники'
  }, {name: 'Моррелл Джо', number: 16, type: 'Полузащитники'}, {
    name: 'Рэмзи Аарон',
    number: 10,
    type: 'Полузащитники'
  }, {name: 'Смит Мэттью', number: 7, type: 'Полузащитники'}, {
    name: 'Уилсон Харри',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Уильямс Джонатан', number: 8, type: 'Полузащитники'}, {
    name: 'Бэйл Гарет',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Джонсон Бреннан', number: 9, type: 'Нападающие'}, {
    name: 'Мур Киффер',
    number: 13,
    type: 'Нападающие'
  }, {name: 'Томас Сорба', number: 7, type: 'Нападающие'}, {
    name: 'Харрис Марк',
    number: 29,
    type: 'Нападающие'
  }, {name: 'Пейдж Роберт', type: 'Тренер'}],
  f9OppQjp: [{name: 'Армани Франко', number: 1, type: 'Вратари'}, {
    name: 'Мартинес Эмилиано',
    number: 23,
    type: 'Вратари'
  }, {name: 'Рулли Жеронимо', number: 12, type: 'Вратари'}, {
    name: 'Акуна Маркус',
    number: 8,
    type: 'Защитники'
  }, {name: 'Мартинес Лисандро', number: 25, type: 'Защитники'}, {
    name: 'Молина Науэль',
    number: 26,
    type: 'Защитники'
  }, {name: 'Монтиэль Гонсало', number: 4, type: 'Защитники'}, {
    name: 'Отаменди Николас',
    number: 19,
    type: 'Защитники'
  }, {name: 'Песселья Герман', number: 6, type: 'Защитники'}, {
    name: 'Ромеро Кристиан Габриэль',
    number: 13,
    type: 'Защитники'
  }, {name: 'Тальяфико Николас', number: 3, type: 'Защитники'}, {
    name: 'Фойт Хуан',
    number: 8,
    type: 'Защитники'
  }, {name: 'Альмада Тьяго', number: 16, type: 'Полузащитники'}, {
    name: 'Де Паул Родриго',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Корреа Анхель', number: 15, type: 'Полузащитники'}, {
    name: 'Макаллистер Алексис',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Паласиос Эсекиэль', number: 14, type: 'Полузащитники'}, {
    name: 'Папу Гомес',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Паредес Леандро', number: 5, type: 'Полузащитники'}, {
    name: 'Родригес Гвидо',
    number: 18,
    type: 'Полузащитники'
  }, {name: 'Фернандес Энцо', number: 24, type: 'Полузащитники'}, {
    name: 'Альварес Хулиан',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Ди Мария Анхель', number: 11, type: 'Нападающие'}, {
    name: 'Дибала Пауло',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Мартинес Лаутаро', number: 22, type: 'Нападающие'}, {
    name: 'Месси Лионель',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Скалони Лионель', type: 'Тренер'}],
  '2HzmcynI': [{name: 'Грабара Камиль', number: 22, type: 'Вратари'}, {
    name: 'Скорупски Лукаш',
    number: 12,
    type: 'Вратари'
  }, {name: 'Щенсный Войцех', number: 1, type: 'Вратари'}, {
    name: 'Беднарек Ян',
    number: 5,
    type: 'Защитники'
  }, {name: 'Берешинский Бартош', number: 18, type: 'Защитники'}, {
    name: 'Ветеска Матеуш',
    number: 4,
    type: 'Защитники'
  }, {name: 'Глик Камиль', number: 15, type: 'Защитники'}, {
    name: 'Гумми Роберт',
    number: 25,
    type: 'Защитники'
  }, {name: 'Енджейчик Артур', number: 3, type: 'Защитники'}, {
    name: 'Кивиор Якуб',
    number: 14,
    type: 'Защитники'
  }, {name: 'Кэш Мэтти', number: 2, type: 'Защитники'}, {
    name: 'Белик Кристиан',
    number: 31,
    type: 'Полузащитники'
  }, {name: 'Гросицкий Камиль', number: 11, type: 'Полузащитники'}, {
    name: 'Журковски Шимон',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Залевски Никола', number: 21, type: 'Полузащитники'}, {
    name: 'Зелиньски Петр',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Каминьский Якуб', number: 13, type: 'Полузащитники'}, {
    name: 'Крыховяк Гжегож',
    number: 10,
    type: 'Полузащитники'
  }, {name: 'Франковски Пшемыслав', number: 24, type: 'Полузащитники'}, {
    name: 'Шиманский Себастьян',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Шиманьский Дамиан', number: 4, type: 'Полузащитники'}, {
    name: 'Левандовски Роберт',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Милик Аркадиуш', number: 7, type: 'Нападающие'}, {
    name: 'Пентек Кшиштоф',
    number: 23,
    type: 'Нападающие'
  }, {name: 'Свидерски Кароль', number: 16, type: 'Нападающие'}, {
    name: 'Скурась Михал',
    number: 26,
    type: 'Нападающие'
  }, {name: 'Михневич Чеслав', type: 'Тренер'}],
  O6iHcNkd: [{name: 'Кота Родольфо', number: 12, type: 'Вратари'}, {
    name: 'Очоа Гильермо',
    number: 13,
    type: 'Вратари'
  }, {name: 'Талавера Альфредо', number: 1, type: 'Вратари'}, {
    name: 'Альварес Кевин',
    number: 26,
    type: 'Защитники'
  }, {name: 'Альварес Эдсон', number: 4, type: 'Защитники'}, {
    name: 'Араухо Нестор',
    number: 2,
    type: 'Защитники'
  }, {name: 'Артеага Херардо', number: 6, type: 'Защитники'}, {
    name: 'Васкес Йохан',
    number: 5,
    type: 'Защитники'
  }, {name: 'Гальярдо Хесус', number: 23, type: 'Защитники'}, {
    name: 'Монтес Сезар',
    number: 3,
    type: 'Защитники'
  }, {name: 'Морено Эктор', number: 15, type: 'Защитники'}, {
    name: 'Санчес Хорхе',
    number: 19,
    type: 'Защитники'
  }, {name: 'Альварадо Роберто', number: 25, type: 'Полузащитники'}, {
    name: 'Антуна Уриэль',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Гуардадо Андрес', number: 18, type: 'Полузащитники'}, {
    name: 'Гутьеррес Эрик',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Пинеда Орбелин', number: 13, type: 'Полузащитники'}, {
    name: 'Родригес Карлос',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Ромо Луис', number: 7, type: 'Полузащитники'}, {
    name: 'Чавес Луис',
    number: 24,
    type: 'Полузащитники'
  }, {name: 'Эррера Эктор', number: 16, type: 'Полузащитники'}, {
    name: 'Funes Mori Рожелиу',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Вега Алексис', number: 10, type: 'Нападающие'}, {
    name: 'Лосано Ирвинг',
    number: 22,
    type: 'Нападающие'
  }, {name: 'Мартин Хенри', number: 20, type: 'Нападающие'}, {name: 'Хименес Рауль', number: 9, type: 'Нападающие'}],
  biSY8ox4: [{name: 'Al Aqidi Nawaf', number: 22, type: 'Вратари'}, {
    name: 'Al Rubaie Мохаммед',
    number: 1,
    type: 'Вратари'
  }, {name: 'Аль-Оваис Мохаммед', number: 21, type: 'Вратари'}, {
    name: 'Abdulhamid Сауд',
    number: 66,
    type: 'Защитники'
  }, {name: 'Al Amri Абдулла', number: 5, type: 'Защитники'}, {
    name: 'Al Boleahi Али',
    number: 5,
    type: 'Защитники'
  }, {name: 'Al Breik Мохамед', number: 6, type: 'Защитники'}, {
    name: 'Al Ghannam Sultan',
    number: 2,
    type: 'Защитники'
  }, {name: 'Аль-Тамбакти Хассан', number: 17, type: 'Защитники'}, {
    name: 'Маду Абдулла',
    number: 3,
    type: 'Защитники'
  }, {name: 'аль-Шахрани Яссер', number: 13, type: 'Защитники'}, {
    name: 'Al Hassan Али',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Al Najei Sami', number: 14, type: 'Полузащитники'}, {
    name: 'Sharahili Riad',
    number: 89,
    type: 'Полузащитники'
  }, {name: 'Аль-Даусари Насер', number: 16, type: 'Полузащитники'}, {
    name: 'Аль-Малки Абдуулла',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Канно Мохамед', number: 28, type: 'Полузащитники'}, {
    name: 'Отайф Абдулла',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'аль-Давсари Салем', number: 10, type: 'Полузащитники'}, {
    name: 'аль-Фараж Салман',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Al Buraikan Фирас', number: 9, type: 'Нападающие'}, {
    name: 'Al Oboud Abdulrahman',
    number: 20,
    type: 'Нападающие'
  }, {name: 'Asiri Haitham', number: 25, type: 'Нападающие'}, {
    name: 'Бахебри Хаттан',
    number: 19,
    type: 'Нападающие'
  }, {name: 'аль-Абид Наваф', number: 18, type: 'Нападающие'}, {
    name: 'аль-Шехри Салех',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Ренар Эрве', type: 'Тренер'}],
  QkGeVG1n: [{name: 'Ареоля Альфонс', number: 23, type: 'Вратари'}, {
    name: 'Льорис Уго',
    number: 1,
    type: 'Вратари'
  }, {name: 'Манданда Стив', number: 16, type: 'Вратари'}, {
    name: 'Варан Рафаэль',
    number: 4,
    type: 'Защитники'
  }, {name: 'Дисаси Аксель', number: 3, type: 'Защитники'}, {
    name: 'Конате Ибраима',
    number: 24,
    type: 'Защитники'
  }, {name: 'Кунде Жюль', number: 5, type: 'Защитники'}, {
    name: 'Павар Бенжамин',
    number: 2,
    type: 'Защитники'
  }, {name: 'Салиба Вильям', number: 17, type: 'Защитники'}, {
    name: 'Упамекано Дайо',
    number: 18,
    type: 'Защитники'
  }, {name: 'Эрнандес Лукас', number: 21, type: 'Защитники'}, {
    name: 'Эрнандес Тео',
    number: 22,
    type: 'Защитники'
  }, {name: 'Верету Джордан', number: 15, type: 'Полузащитники'}, {
    name: 'Гендузи Маттео',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Камавинга Эдуарду', number: 25, type: 'Полузащитники'}, {
    name: 'Рабьо Адриен',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Тчуамени Орельен', number: 8, type: 'Полузащитники'}, {
    name: 'Фофана Юссуф',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Гризманн Антуан', number: 7, type: 'Нападающие'}, {
    name: 'Дембеле Усман',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Жиру Оливье', number: 9, type: 'Нападающие'}, {
    name: 'Коло-Муани Рандаль',
    number: 12,
    type: 'Нападающие'
  }, {name: 'Коман Кингсли', number: 20, type: 'Нападающие'}, {
    name: 'Мбаппе Килиан',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Тюрам Маркус', number: 26, type: 'Нападающие'}, {name: 'Дешам Дидье', type: 'Тренер'}],
  xSrf6qMM: [{name: 'Вукович Дэнни', number: 20, type: 'Вратари'}, {
    name: 'Райан Мэтью',
    number: 1,
    type: 'Вратари'
  }, {name: 'Редмэйн Эндрю', number: 1, type: 'Вратари'}, {
    name: 'Аткинсон Натаниэль',
    number: 12,
    type: 'Защитники'
  }, {name: 'Бехич Азиз', number: 16, type: 'Защитники'}, {
    name: 'Денг Томас',
    number: 20,
    type: 'Защитники'
  }, {name: 'Карачич Фран', number: 2, type: 'Защитники'}, {
    name: 'Кинг Джоэл',
    number: 24,
    type: 'Защитники'
  }, {name: 'Райт Бэйли', number: 8, type: 'Защитники'}, {
    name: 'Роулс Кай',
    number: 4,
    type: 'Защитники'
  }, {name: 'Суттар Хэрри', number: 5, type: 'Защитники'}, {
    name: 'Баккус Киану',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Девлин Кэмерон', number: 14, type: 'Полузащитники'}, {
    name: 'Дегенек Милош',
    number: 2,
    type: 'Полузащитники'
  }, {name: 'Ирвин Джексон', number: 22, type: 'Полузащитники'}, {
    name: 'Мабиль Авер',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'Макги Райли', number: 8, type: 'Полузащитники'}, {
    name: 'Муй Аарон',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Хрустич Айдин', number: 10, type: 'Полузащитники'}, {
    name: 'Гудвин Крэйг',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Дьюк Митчелл', number: 15, type: 'Нападающие'}, {
    name: 'Каммингс Джейсон',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Куол Гаранг', number: 14, type: 'Нападающие'}, {
    name: 'Леки Мэттью',
    number: 7,
    type: 'Нападающие'
  }, {name: 'Макларен Джейми', number: 9, type: 'Нападающие'}, {
    name: 'Тилио Марко',
    number: 23,
    type: 'Нападающие'
  }, {name: 'Арнольд Грэм', type: 'Тренер'}],
  QqZVYk95: [{name: 'Ассен Муэз', number: 26, type: 'Вратари'}, {
    name: 'Балбули Аймен',
    number: 1,
    type: 'Вратари'
  }, {name: 'Бен Саид Бешир', number: 22, type: 'Вратари'}, {
    name: 'Дамен Аймен',
    number: 16,
    type: 'Вратари'
  }, {name: 'Абди Али', number: 24, type: 'Защитники'}, {
    name: 'Бронн Дилан',
    number: 6,
    type: 'Защитники'
  }, {name: 'Дрэгер Мохамед', number: 20, type: 'Защитники'}, {
    name: 'Ифа Билель',
    number: 2,
    type: 'Защитники'
  }, {name: 'Кешрида Важди', number: 2, type: 'Защитники'}, {
    name: 'Маалул Али',
    number: 21,
    type: 'Защитники'
  }, {name: 'Мерия Яссин', number: 4, type: 'Защитники'}, {
    name: 'Талби Монтассар',
    number: 3,
    type: 'Защитники'
  }, {name: 'Бен Ромдхане Мохамед Али', number: 15, type: 'Полузащитники'}, {
    name: 'Гандри Надер',
    number: 5,
    type: 'Полузащитники'
  }, {name: 'Лайдуни Аисса', number: 14, type: 'Полузащитники'}, {
    name: 'Меджбри Ганнибал',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Мсакни Юссеф', number: 7, type: 'Полузащитники'}, {
    name: 'Сасси Ферджани',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Слимане Анис', number: 25, type: 'Полузащитники'}, {
    name: 'Слити Наим',
    number: 10,
    type: 'Полузащитники'
  }, {name: 'Шалели Гайлен', number: 18, type: 'Полузащитники'}, {
    name: 'Шкири Эльес',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Джазири Сейфеддин', number: 30, type: 'Нападающие'}, {
    name: 'Джебали Иссам',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Хенисси Таха', number: 11, type: 'Нападающие'}, {name: 'Кадри Джалел', type: 'Тренер'}],
  '0KUdxQVi': [{name: 'Кристенсен Оливер', number: 16, type: 'Вратари'}, {
    name: 'Роннов Фредерик',
    number: 22,
    type: 'Вратари'
  }, {name: 'Шмейхель Каспер', number: 1, type: 'Вратари'}, {
    name: 'Андерсен Йоаким',
    number: 2,
    type: 'Защитники'
  }, {name: 'Ба Александр', number: 6, type: 'Защитники'}, {
    name: 'Васс Даниэль',
    number: 18,
    type: 'Защитники'
  }, {name: 'Кристенсен Андреас', number: 6, type: 'Защитники'}, {
    name: 'Кристенсен Расмус',
    number: 13,
    type: 'Защитники'
  }, {name: 'Кьер Симон', number: 4, type: 'Защитники'}, {
    name: 'Мехле Йоаким',
    number: 5,
    type: 'Защитники'
  }, {name: 'Нельссон Виктор', number: 3, type: 'Защитники'}, {
    name: 'Дамсгард Миккель',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Дилэйни Томас', number: 8, type: 'Полузащитники'}, {
    name: 'Йенсен Матиас',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Ларсен Йенс', number: 17, type: 'Полузащитники'}, {
    name: 'Линдстрем Йеспер',
    number: 25,
    type: 'Полузащитники'
  }, {name: 'Нёргор Кристиан', number: 15, type: 'Полузащитники'}, {
    name: 'Сков Ольсен Андреас',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'Хейбьерг Пьер', number: 23, type: 'Полузащитники'}, {
    name: 'Эриксен Кристиан',
    number: 10,
    type: 'Полузащитники'
  }, {name: 'Брэйтуэйт Мартин', number: 9, type: 'Нападающие'}, {
    name: 'Винд Йонас',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Дольберг Каспер', number: 12, type: 'Нападающие'}, {
    name: 'Корнелиус Андреас',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Поульсен Юссуф', number: 20, type: 'Нападающие'}, {
    name: 'Сков Роберт',
    number: 24,
    type: 'Нападающие'
  }, {name: 'Хьюлманн Каспер', type: 'Тренер'}],
  ULXPdOUj: [{name: 'Гонда Сюити', number: 12, type: 'Вратари'}, {
    name: 'Кавасима Эдзи',
    number: 16,
    type: 'Вратари'
  }, {name: 'Шмидт Даниэль', number: 23, type: 'Вратари'}, {
    name: 'Итакура Ко',
    number: 4,
    type: 'Защитники'
  }, {name: 'Йосида Мая', number: 22, type: 'Защитники'}, {
    name: 'Нагатомо Юто',
    number: 5,
    type: 'Защитники'
  }, {name: 'Сакаи Хироки', number: 19, type: 'Защитники'}, {
    name: 'Томиясу Такехиро',
    number: 16,
    type: 'Защитники'
  }, {name: 'Яманэ Мики', number: 2, type: 'Защитники'}, {
    name: 'Доан Рицу',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Ито Хироки', number: 26, type: 'Полузащитники'}, {
    name: 'Камада Даити',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Митома Каору', number: 9, type: 'Полузащитники'}, {
    name: 'Морита Хидемаса',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Сибасаки Гаку', number: 8, type: 'Полузащитники'}, {
    name: 'Сома Юки',
    number: 24,
    type: 'Полузащитники'
  }, {name: 'Танака Ао', number: 17, type: 'Полузащитники'}, {
    name: 'Танигути Сого',
    number: 3,
    type: 'Полузащитники'
  }, {name: 'Эндо Ватару', number: 6, type: 'Полузащитники'}, {
    name: 'Асано Такума',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Дзюня Ито', number: 14, type: 'Нападающие'}, {
    name: 'Кубо Такефуса',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Матино Сюто', number: 20, type: 'Нападающие'}, {
    name: 'Маэда Дайзен',
    number: 38,
    type: 'Нападающие'
  }, {name: 'Минамино Такуми', number: 10, type: 'Нападающие'}, {
    name: 'Уэда Аясе',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Мориясу Хадзимэ', type: 'Тренер'}],
  bLyo6mco: [{name: 'Рая Давид', number: 13, type: 'Вратари'}, {
    name: 'Санчес Роберт',
    number: 1,
    type: 'Вратари'
  }, {name: 'Симон Унаи', number: 23, type: 'Вратари'}, {
    name: 'Альба Жорди',
    number: 18,
    type: 'Защитники'
  }, {name: 'Аспиликуэта Сесар', number: 2, type: 'Защитники'}, {
    name: 'Бальде Алехандро',
    number: null,
    type: 'Защитники'
  }, {name: 'Гарсия Эрик', number: 3, type: 'Защитники'}, {
    name: 'Гильямон Уго',
    number: 15,
    type: 'Защитники'
  }, {name: 'Карвахаль Даниэль', number: 20, type: 'Защитники'}, {
    name: 'Лапорт Аймерик',
    number: 24,
    type: 'Защитники'
  }, {name: 'Торрес По', number: 4, type: 'Защитники'}, {
    name: 'Гави',
    number: 9,
    type: 'Полузащитники'
  }, {name: 'Коке', number: 8, type: 'Полузащитники'}, {
    name: 'Льоренте Маркос',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Ольмо Дани', number: 21, type: 'Полузащитники'}, {
    name: 'Педри',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Родри', number: 16, type: 'Полузащитники'}, {
    name: 'Солер Карлос',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Асенсио Марко', number: 10, type: 'Нападающие'}, {
    name: 'Мората Альваро',
    number: 7,
    type: 'Нападающие'
  }, {name: 'Пино Йереми', number: 17, type: 'Нападающие'}, {
    name: 'Сарабия Пабло',
    number: 22,
    type: 'Нападающие'
  }, {name: 'Торрес Ферран', number: 11, type: 'Нападающие'}, {
    name: 'Уильямс Нико',
    number: 12,
    type: 'Нападающие'
  }, {name: 'Фати Ансу', number: 25, type: 'Нападающие'}, {name: 'de la Fuente Луис', type: 'Тренер'}],
  ptQide1O: [{name: 'Нойер Мануэль', number: 1, type: 'Вратари'}, {
    name: 'Тер Штеген Марк-Андре',
    number: 22,
    type: 'Вратари'
  }, {name: 'Трапп Кевин', number: 12, type: 'Вратари'}, {
    name: 'Белла-Котчап Армел',
    number: 25,
    type: 'Защитники'
  }, {name: 'Гинтер Маттиас', number: 4, type: 'Защитники'}, {
    name: 'Гюнтер Кристиан',
    number: 20,
    type: 'Защитники'
  }, {name: 'Зюле Никлас', number: 15, type: 'Защитники'}, {
    name: 'Керер Тило',
    number: 5,
    type: 'Защитники'
  }, {name: 'Клостерманн Лукас', number: 16, type: 'Защитники'}, {
    name: 'Рюдигер Антонио',
    number: 2,
    type: 'Защитники'
  }, {name: 'Шлоттербек Нико', number: 23, type: 'Защитники'}, {
    name: 'Горетцка Леон',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Гюндоган Илкай', number: 21, type: 'Полузащитники'}, {
    name: 'Гётце Марио',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'Киммих Йозуа', number: 6, type: 'Полузащитники'}, {
    name: 'Мусиала Джамаль',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Раум Давид', number: 3, type: 'Полузащитники'}, {
    name: 'Хаверц Кай',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Хофманн Йонас', number: 18, type: 'Полузащитники'}, {
    name: 'Адейеми Карим',
    number: 24,
    type: 'Нападающие'
  }, {name: 'Брандт Юлиан', number: 17, type: 'Нападающие'}, {
    name: 'Гнабри Серж',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Мукоко Юссуфа', number: 26, type: 'Нападающие'}, {
    name: 'Мюллер Томас',
    number: 13,
    type: 'Нападающие'
  }, {name: 'Сане Лерой', number: 19, type: 'Нападающие'}, {
    name: 'Фуллкруг Никлас',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Флик Hansi', type: 'Тренер'}],
  C4ePE2kq: [{name: 'Альварадо Эстебан', number: 1, type: 'Вратари'}, {
    name: 'Навас Кейлор',
    number: 1,
    type: 'Вратари'
  }, {name: 'Секейра Патрик', number: 1, type: 'Вратари'}, {
    name: 'Варгас Хуан',
    number: 3,
    type: 'Защитники'
  }, {name: 'Дуарте Оскар', number: 6, type: 'Защитники'}, {
    name: 'Кальво Франсиско',
    number: 15,
    type: 'Защитники'
  }, {name: 'Лопес Дуглас', number: 8, type: 'Защитники'}, {
    name: 'Мартинес Карлос',
    number: 16,
    type: 'Защитники'
  }, {name: 'Овьедо Брайан', number: 8, type: 'Защитники'}, {
    name: 'Фуллер Кейшер',
    number: 37,
    type: 'Защитники'
  }, {name: 'Агилера Брэндон', number: 20, type: 'Полузащитники'}, {
    name: 'Беннетт Джюисон',
    number: 19,
    type: 'Полузащитники'
  }, {name: 'Борхес Сельсо', number: 5, type: 'Полузащитники'}, {
    name: 'Матаррита Рональд',
    number: 22,
    type: 'Полузащитники'
  }, {name: 'Салас Юстин', number: 14, type: 'Полузащитники'}, {
    name: 'Самора Альваро',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Техеда Ельцин', number: 10, type: 'Полузащитники'}, {
    name: 'Торрес Жерсон',
    number: 28,
    type: 'Полузащитники'
  }, {name: 'Чакон Даниэль', number: 2, type: 'Полузащитники'}, {
    name: 'Вастон Кендалл',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Венегас Хоан', number: 11, type: 'Нападающие'}, {
    name: 'Контрерас Антони',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Кэмпбелл Джоэл', number: 12, type: 'Нападающие'}, {
    name: 'Руис Брайан',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Уилсон Роан', number: 24, type: 'Нападающие'}, {
    name: 'Эрнандес Энтони',
    number: 25,
    type: 'Нападающие'
  }, {name: 'Суарес Luis Fernando', type: 'Тренер'}],
  IDKYO3R8: [{name: 'Боно', number: 1, type: 'Вратари'}, {
    name: 'Мунир',
    number: 12,
    type: 'Вратари'
  }, {name: 'Таньяути Ахмед Реда', number: 22, type: 'Вратари'}, {
    name: 'Attiat-Allah Яхья',
    number: 25,
    type: 'Защитники'
  }, {name: 'Агуэрд Наиф', number: 5, type: 'Защитники'}, {
    name: 'Бенун Бадр',
    number: 24,
    type: 'Защитники'
  }, {name: 'Дари Ашраф', number: 20, type: 'Защитники'}, {
    name: 'Мазрауи Нуссаир',
    number: 3,
    type: 'Защитники'
  }, {name: 'Сесс Ромен', number: 6, type: 'Защитники'}, {
    name: 'Хакими Ашраф',
    number: 2,
    type: 'Защитники'
  }, {name: 'Эль-Ямик Джавад', number: 18, type: 'Защитники'}, {
    name: 'Амалла Селим',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Амрабат Софьян', number: 4, type: 'Полузащитники'}, {
    name: 'Джабране Яхья',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Зиеш Хаким', number: 7, type: 'Полузащитники'}, {
    name: 'Оунахи Аззедин',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Сабири Абдельхамид', number: 11, type: 'Полузащитники'}, {
    name: 'Чеир Илиас',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Эль Ханнус Билал', number: 23, type: 'Полузащитники'}, {
    name: 'Абухляль Закария',
    number: 14,
    type: 'Нападающие'
  }, {name: 'Буфал Софиан', number: 7, type: 'Нападающие'}, {
    name: 'Зарури Анасс',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Хамдалла Абдерразак', number: 9, type: 'Нападающие'}, {
    name: 'Чеддира Валид',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Эз Абде', number: 16, type: 'Нападающие'}, {
    name: 'Эн-Несири Юссеф',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Реграгуи Валид', type: 'Тренер'}],
  K8aznggo: [{name: 'Ivusic Ивица', number: 23, type: 'Вратари'}, {
    name: 'Грбич Иво',
    number: 12,
    type: 'Вратари'
  }, {name: 'Ливакович Доминик', number: 1, type: 'Вратари'}, {
    name: 'Баришич Борна',
    number: 3,
    type: 'Защитники'
  }, {name: 'Вида Домагой', number: 21, type: 'Защитники'}, {
    name: 'Гвардиол Йошко',
    number: 20,
    type: 'Защитники'
  }, {name: 'Ловрен Деян', number: 6, type: 'Защитники'}, {
    name: 'Соса Борна',
    number: 19,
    type: 'Защитники'
  }, {name: 'Станишич Йосип', number: 2, type: 'Защитники'}, {
    name: 'Сутало Йосип',
    number: 24,
    type: 'Защитники'
  }, {name: 'Эрлич Мартин', number: 5, type: 'Защитники'}, {
    name: 'Юранович Йосип',
    number: 22,
    type: 'Защитники'
  }, {name: 'Брозович Марцело', number: 11, type: 'Полузащитники'}, {
    name: 'Влашич Никола',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Ковачич Матео', number: 8, type: 'Полузащитники'}, {
    name: 'Майер Ловро',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Модрич Лука', number: 10, type: 'Полузащитники'}, {
    name: 'Пашалич Марио',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Сучич Лука', number: 25, type: 'Полузащитники'}, {
    name: 'Якич Кристиан',
    number: 26,
    type: 'Полузащитники'
  }, {name: 'Будимир Анте', number: 17, type: 'Нападающие'}, {
    name: 'Крамарич Андрей',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Ливайя Марко', number: 14, type: 'Нападающие'}, {
    name: 'Оршич Мислав',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Перишич Иван', number: 4, type: 'Нападающие'}, {
    name: 'Петкович Бруно',
    number: 16,
    type: 'Нападающие'
  }, {name: 'Далич Златко', type: 'Тренер'}],
  GbB957na: [{name: 'Кастельс Кен', number: 13, type: 'Вратари'}, {
    name: 'Куртуа Тибо',
    number: 1,
    type: 'Вратари'
  }, {name: 'Миньоле Симон', number: 12, type: 'Вратари'}, {
    name: 'Алдервейрелд Тоби',
    number: 2,
    type: 'Защитники'
  }, {name: 'Вертонген Ян', number: 5, type: 'Защитники'}, {
    name: 'Дебас Зено',
    number: 26,
    type: 'Защитники'
  }, {name: 'Кастань Тимоти', number: 21, type: 'Защитники'}, {
    name: 'Мёнье Томас',
    number: 15,
    type: 'Защитники'
  }, {name: 'Теате Артюр', number: 3, type: 'Защитники'}, {
    name: 'Фас Ваут',
    number: 4,
    type: 'Защитники'
  }, {name: 'Азар Торган', number: 16, type: 'Полузащитники'}, {
    name: 'Ванакен Ханс',
    number: 20,
    type: 'Полузащитники'
  }, {name: 'Витцель Аксель', number: 6, type: 'Полузащитники'}, {
    name: 'Де Брюйне Кевин',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Дендокер Леандер', number: 19, type: 'Полузащитники'}, {
    name: 'Онана Амаду',
    number: 18,
    type: 'Полузащитники'
  }, {name: 'Тилеманс Юри', number: 8, type: 'Полузащитники'}, {
    name: 'Троссард Леандро',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'де Кетеларе Шарль', number: 22, type: 'Полузащитники'}, {
    name: 'Азар Эден',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Батшуайи Миши', number: 23, type: 'Нападающие'}, {
    name: 'Доку Жереми',
    number: 25,
    type: 'Нападающие'
  }, {name: 'Карраско Янник', number: 11, type: 'Нападающие'}, {
    name: 'Лукаку Ромелу',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Мертенс Дрис', number: 14, type: 'Нападающие'}, {name: 'Опенда Лои', number: 24, type: 'Нападающие'}],
  x4toKORL: [{name: 'Борьян Милан', number: 18, type: 'Вратари'}, {
    name: 'Пантемис Джеймс',
    number: 16,
    type: 'Вратари'
  }, {name: 'Сен-Клер Дэйн', number: 1, type: 'Вратари'}, {
    name: 'Адекугбе Сэм',
    number: 3,
    type: 'Защитники'
  }, {name: 'Витория Стивен', number: 5, type: 'Защитники'}, {
    name: 'Дэвис Альфонсо',
    number: 19,
    type: 'Защитники'
  }, {name: 'Корнелиус Дерек', number: 25, type: 'Защитники'}, {
    name: 'Ларейя Ричи',
    number: 22,
    type: 'Защитники'
  }, {name: 'Миллер Камаль', number: 4, type: 'Защитники'}, {
    name: 'Уотерман Джоэль',
    number: 26,
    type: 'Защитники'
  }, {name: 'Бьюкенен Тайон', number: 11, type: 'Полузащитники'}, {
    name: 'Джонстон Алистер',
    number: 2,
    type: 'Полузащитники'
  }, {name: 'Кайе Марк', number: 14, type: 'Полузащитники'}, {
    name: 'Коне Исмаэль',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Миллар Лиам', number: 23, type: 'Полузащитники'}, {
    name: 'Осорио Джонатан',
    number: 21,
    type: 'Полузащитники'
  }, {name: 'Пьетт Самуэль', number: 6, type: 'Полузащитники'}, {
    name: 'Уотерспун Дэвид',
    number: 10,
    type: 'Полузащитники'
  }, {name: 'Фрейзер Лиэм', number: 4, type: 'Полузащитники'}, {
    name: 'Хатчинсон Атиба',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Эуштакиу Стефен', number: 7, type: 'Полузащитники'}, {
    name: 'Дэвид Хонатан',
    number: 20,
    type: 'Нападающие'
  }, {name: 'Каваллини Лукас', number: 9, type: 'Нападающие'}, {
    name: 'Ларин Кайл',
    number: 17,
    type: 'Нападающие'
  }, {name: 'Угбо Ике', number: 12, type: 'Нападающие'}, {
    name: 'Хойлетт Джуниор',
    number: 23,
    type: 'Нападающие'
  }, {name: 'Хердман Джон', type: 'Тренер'}],
  I9l9aqLq: [{name: 'Алиссон', number: 1, type: 'Вратари'}, {
    name: 'Вевертон',
    number: 12,
    type: 'Вратари'
  }, {name: 'Эдерсон', number: 23, type: 'Вратари'}, {
    name: 'Алекс Сандро',
    number: 6,
    type: 'Защитники'
  }, {name: 'Бремер', number: 24, type: 'Защитники'}, {
    name: 'Дани Алвес',
    number: 13,
    type: 'Защитники'
  }, {name: 'Данило', number: 2, type: 'Защитники'}, {
    name: 'Маркиньос',
    number: 4,
    type: 'Защитники'
  }, {name: 'Милитао Эдер', number: 14, type: 'Защитники'}, {
    name: 'Силва Тьяго',
    number: 3,
    type: 'Защитники'
  }, {name: 'Теллес Алекс', number: 16, type: 'Защитники'}, {
    name: 'Бруно Гимараэш',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Каземиро', number: 5, type: 'Полузащитники'}, {
    name: 'Пакета Лукас',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Фабиньо', number: 15, type: 'Полузащитники'}, {
    name: 'Фред',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Эвертон Рибейро', number: 22, type: 'Полузащитники'}, {
    name: 'Антони',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Винисиус Жуниор', number: 20, type: 'Нападающие'}, {
    name: 'Жезус Габриэл',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Мартинелли Габриэль', number: 26, type: 'Нападающие'}, {
    name: 'Неймар',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Педро', number: 25, type: 'Нападающие'}, {
    name: 'Рафинья',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Ришарлисон', number: 9, type: 'Нападающие'}, {
    name: 'Родриго',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Тите', type: 'Тренер'}],
  rHJ2vy1B: [{name: 'Зоммер Янн', number: 1, type: 'Вратари'}, {
    name: 'Кобель Грегор',
    number: 21,
    type: 'Вратари'
  }, {name: 'Кён Филипп', number: 24, type: 'Вратари'}, {
    name: 'Омлин Йонас',
    number: 12,
    type: 'Вратари'
  }, {name: 'Аканжи Мануэль', number: 5, type: 'Защитники'}, {
    name: 'Видмер Сильван',
    number: 3,
    type: 'Защитники'
  }, {name: 'Кюмарт Эрай', number: 18, type: 'Защитники'}, {
    name: 'Родригес Рикардо',
    number: 13,
    type: 'Защитники'
  }, {name: 'Шер Фабиан', number: 22, type: 'Защитники'}, {
    name: 'Эльведи Нико',
    number: 4,
    type: 'Защитники'
  }, {name: 'Jashari Ардон', number: 26, type: 'Полузащитники'}, {
    name: 'Варгас Рубен',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Джака Гранит', number: 10, type: 'Полузащитники'}, {
    name: 'Закария Денис',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Ридер Фабиан', number: 25, type: 'Полузащитники'}, {
    name: 'Соу Джибриль',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Фасснахт Кристиан', number: 16, type: 'Полузащитники'}, {
    name: 'Фернандес Эдмилсон',
    number: 2,
    type: 'Полузащитники'
  }, {name: 'Фрай Фабиан', number: 20, type: 'Полузащитники'}, {
    name: 'Фройлер Ремо',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Шакири Джердан', number: 23, type: 'Полузащитники'}, {
    name: 'Штеффен Ренато',
    number: 11,
    type: 'Полузащитники'
  }, {name: 'Эбишер Мишель', number: 14, type: 'Полузащитники'}, {
    name: 'Окафор Ноа',
    number: 19,
    type: 'Нападающие'
  }, {name: 'Сеферович Харис', number: 9, type: 'Нападающие'}, {
    name: 'Эмболо Бреел',
    number: 7,
    type: 'Нападающие'
  }, {name: 'Якин Мурат', type: 'Тренер'}],
  zk1uVG2D: [{name: 'Нгапандуэнбу Симон', number: 1, type: 'Вратари'}, {
    name: 'Онана Андре',
    number: 23,
    type: 'Вратари'
  }, {name: 'Эпасси Девис', number: 16, type: 'Вратари'}, {
    name: 'Ву Кристофер',
    number: 4,
    type: 'Защитники'
  }, {name: 'Кастеллетто Жан-Шарль', number: 21, type: 'Защитники'}, {
    name: 'Мбаизо Оливье',
    number: 17,
    type: 'Защитники'
  }, {name: 'Н\'Кулу Николя', number: 3, type: 'Защитники'}, {
    name: 'Толо Нуху',
    number: 25,
    type: 'Защитники'
  }, {name: 'Фай Коллинс', number: 19, type: 'Защитники'}, {
    name: 'Эбоссе Энцо',
    number: 24,
    type: 'Защитники'
  }, {name: 'Ангисса Андре Замбо', number: 8, type: 'Полузащитники'}, {
    name: 'Кунде Пьер',
    number: 15,
    type: 'Полузащитники'
  }, {name: 'Нгамалё Николас', number: 6, type: 'Полузащитники'}, {
    name: 'Нгом Мбекели Джером',
    number: 2,
    type: 'Полузащитники'
  }, {name: 'Нтчам Оливье', number: 10, type: 'Полузащитники'}, {
    name: 'Онгла Мартин',
    number: 18,
    type: 'Полузащитники'
  }, {name: 'Ондуа Гаэль', number: 5, type: 'Полузащитники'}, {
    name: 'Ум Гуе Самуэль',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Абубакар Венсан', number: 9, type: 'Нападающие'}, {
    name: 'Бассогог Кристиан',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Мару Суаибу', number: 26, type: 'Нападающие'}, {
    name: 'Мбеумо Брайан',
    number: 20,
    type: 'Нападающие'
  }, {name: 'Н\'Куду Жорж-Кевин', number: 7, type: 'Нападающие'}, {
    name: 'Нсаме Жан-Пьер',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Токо Экамби Карл', number: 12, type: 'Нападающие'}, {
    name: 'Шупо-Мотинг Эрик Максим',
    number: 13,
    type: 'Нападающие'
  }, {name: 'Сонг Ригобер', type: 'Тренер'}],
  '8Kl6iq0i': [{name: 'Дмитрович Марко', number: 1, type: 'Вратари'}, {
    name: 'Милинкович-Савич Ваня',
    number: 23,
    type: 'Вратари'
  }, {name: 'Райкович Предраг', number: 12, type: 'Вратари'}, {
    name: 'Бабич Срджан',
    number: 15,
    type: 'Защитники'
  }, {name: 'Велькович Милош', number: 5, type: 'Защитники'}, {
    name: 'Миленкович Никола',
    number: 4,
    type: 'Защитники'
  }, {name: 'Митрович Стефан', number: 13, type: 'Защитники'}, {
    name: 'Младенович Филип',
    number: 25,
    type: 'Защитники'
  }, {name: 'Павлович Страхинья', number: 2, type: 'Защитники'}, {
    name: 'Эракович Страхинья',
    number: 3,
    type: 'Защитники'
  }, {name: 'Груич Марко', number: 16, type: 'Полузащитники'}, {
    name: 'Гудель Неманья',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Джуричич Филип', number: 21, type: 'Полузащитники'}, {
    name: 'Живкович Андрия',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Илич Иван', number: 24, type: 'Полузащитники'}, {
    name: 'Лазович Дарко',
    number: 22,
    type: 'Полузащитники'
  }, {name: 'Лукич Саша', number: 16, type: 'Полузащитники'}, {
    name: 'Максимович Неманья',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Милинкович-Савич Сергей', number: 20, type: 'Полузащитники'}, {
    name: 'Радоньич Неманья',
    number: 7,
    type: 'Полузащитники'
  }, {name: 'Рачич Урош', number: 19, type: 'Полузащитники'}, {
    name: 'Влахович Душан',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Йович Лука', number: 11, type: 'Нападающие'}, {
    name: 'Костич Филип',
    number: 17,
    type: 'Нападающие'
  }, {name: 'Митрович Александар', number: 9, type: 'Нападающие'}, {
    name: 'Тадич Душан',
    number: 10,
    type: 'Нападающие'
  }, {name: 'Stojkovic Dragan', type: 'Тренер'}],
  WvJrjFVN: [{name: 'Жозе Са', number: 12, type: 'Вратари'}, {
    name: 'Кошта Diogo',
    number: 99,
    type: 'Вратари'
  }, {name: 'Патрисиу Руй', number: 1, type: 'Вратари'}, {
    name: 'Антониу Силва',
    number: 66,
    type: 'Защитники'
  }, {name: 'Геррейру Рафаэль', number: 5, type: 'Защитники'}, {
    name: 'Далот Диого',
    number: 2,
    type: 'Защитники'
  }, {name: 'Диаш Рубен', number: 4, type: 'Защитники'}, {
    name: 'Канселу Жоау',
    number: 20,
    type: 'Защитники'
  }, {name: 'Мендеш Нуну', number: 19, type: 'Защитники'}, {
    name: 'Пепе',
    number: 3,
    type: 'Защитники'
  }, {name: 'Витинья', number: 16, type: 'Полузащитники'}, {
    name: 'Жоау Мариу',
    number: 17,
    type: 'Полузащитники'
  }, {name: 'Карвалью Уильям', number: 14, type: 'Полузащитники'}, {
    name: 'Матеуш Нуньеш',
    number: 23,
    type: 'Полузащитники'
  }, {name: 'Невеш Рубен', number: 18, type: 'Полузащитники'}, {
    name: 'Отавио',
    number: 25,
    type: 'Полузащитники'
  }, {name: 'Палинья Жоау', number: 6, type: 'Полузащитники'}, {
    name: 'Перейра Danilo',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Силва Бернарду', number: 10, type: 'Полузащитники'}, {
    name: 'Фернандеш Бруно',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Андре Силва', number: 9, type: 'Нападающие'}, {
    name: 'Жоау Феликс',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Леау Рафаэль', number: 15, type: 'Нападающие'}, {
    name: 'Орта Рикарду',
    number: 21,
    type: 'Нападающие'
  }, {name: 'Рамуш Гонсалу', number: 88, type: 'Нападающие'}, {
    name: 'Роналду Криштиану',
    number: 7,
    type: 'Нападающие'
  }, {name: 'Сантуш Фернандо', type: 'Тренер'}],
  K6Gs7P6G: [{name: 'Ким Сын-Гю', number: 1, type: 'Вратари'}, {
    name: 'Сон Бом Гын',
    number: 12,
    type: 'Вратари'
  }, {name: 'Чо Хён У', number: 21, type: 'Вратари'}, {
    name: 'Квон Кён Вон',
    number: 20,
    type: 'Защитники'
  }, {name: 'Ким Ён Вон', number: 19, type: 'Защитники'}, {
    name: 'Ким Мин Чжэ',
    number: 4,
    type: 'Защитники'
  }, {name: 'Ким Мун Хван', number: 15, type: 'Защитники'}, {
    name: 'Ким Чжин-Су',
    number: 3,
    type: 'Защитники'
  }, {name: 'Хон Чхоль', number: 14, type: 'Защитники'}, {
    name: 'Чо Ю Мин',
    number: 24,
    type: 'Защитники'
  }, {name: 'Юн Чон Гю', number: 2, type: 'Защитники'}, {
    name: 'Бэк Сын Хо',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Квон Чхан Хун', number: 22, type: 'Полузащитники'}, {
    name: 'Ким Тэ-Хван',
    number: 23,
    type: 'Полузащитники'
  }, {name: 'Ли Джэ Сон', number: 10, type: 'Полузащитники'}, {
    name: 'Ли Кан Ин',
    number: 18,
    type: 'Полузащитники'
  }, {name: 'На Санг Хо', number: 17, type: 'Полузащитники'}, {
    name: 'Сон Джун Хо',
    number: 13,
    type: 'Полузащитники'
  }, {name: 'Хван Ин-Бом', number: 6, type: 'Полузащитники'}, {
    name: 'Чон У Ён',
    number: 25,
    type: 'Полузащитники'
  }, {name: 'Ян Хён Джун', number: 47, type: 'Полузащитники'}, {
    name: 'Сон Мин-Кю',
    number: 26,
    type: 'Нападающие'
  }, {name: 'Сон Хын Мин', number: 7, type: 'Нападающие'}, {
    name: 'Хван Ви Чо',
    number: 16,
    type: 'Нападающие'
  }, {name: 'Хван Хи Чхан', number: 11, type: 'Нападающие'}, {
    name: 'Чо Хе-сон',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Бенту Паулу', type: 'Тренер'}],
  xMk44orG: [{name: 'Муслера Фернандо', number: 1, type: 'Вратари'}, {
    name: 'Рочет Серхио',
    number: 23,
    type: 'Вратари'
  }, {name: 'Соса Себастьян', number: 12, type: 'Вратари'}, {
    name: 'Араухо Рональд',
    number: 4,
    type: 'Защитники'
  }, {name: 'Винья Матиас', number: 17, type: 'Защитники'}, {
    name: 'Гильермо Варела',
    number: 13,
    type: 'Защитники'
  }, {name: 'Годин Диего', number: 3, type: 'Защитники'}, {
    name: 'Касерес Мартин',
    number: 22,
    type: 'Защитники'
  }, {name: 'Коатес Себастьян', number: 4, type: 'Защитники'}, {
    name: 'Оливера Матиас',
    number: 16,
    type: 'Защитники'
  }, {name: 'Родригес Хосе Луис', number: 26, type: 'Защитники'}, {
    name: 'Хименес Хосе Мария',
    number: 2,
    type: 'Защитники'
  }, {name: 'de Arrascaeta Джорджиан', number: 10, type: 'Полузащитники'}, {
    name: 'Бентанкур Родриго',
    number: 6,
    type: 'Полузащитники'
  }, {name: 'Вальверде Федерико', number: 15, type: 'Полузащитники'}, {
    name: 'Весино Матиас',
    number: 5,
    type: 'Полузащитники'
  }, {name: 'Де Ла Круз Николас', number: 7, type: 'Полузащитники'}, {
    name: 'Каноббио Агустин',
    number: 24,
    type: 'Полузащитники'
  }, {name: 'Пеллистри Факундо', number: 8, type: 'Полузащитники'}, {
    name: 'Торрейра Лукас',
    number: 14,
    type: 'Полузащитники'
  }, {name: 'Угарте Мануэль', number: 15, type: 'Полузащитники'}, {
    name: 'Гомес Макси',
    number: 18,
    type: 'Нападающие'
  }, {name: 'Кавани Эдинсон', number: 21, type: 'Нападающие'}, {
    name: 'Нуньес Дарвин',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Суарес Луис', number: 9, type: 'Нападающие'}, {
    name: 'Торрес Факундо',
    number: 20,
    type: 'Нападающие'
  }, {name: 'Альфонсо Диего', type: 'Тренер'}],
  nNBjHale: [{name: 'Ати Зиги Лоуренс', number: 1, type: 'Вратари'}, {
    name: 'Данлад Ибрахим',
    number: 12,
    type: 'Вратари'
  }, {name: 'Нурудин Абдул', number: 16, type: 'Вратари'}, {
    name: 'Айду Джозеф',
    number: 15,
    type: 'Защитники'
  }, {name: 'Амарте Даниэль', number: 18, type: 'Защитники'}, {
    name: 'Баба Абдул Рахман',
    number: 12,
    type: 'Защитники'
  }, {name: 'Джику Александр', number: 24, type: 'Защитники'}, {
    name: 'Лэмпти Тарик',
    number: 2,
    type: 'Защитники'
  }, {name: 'Менса Гидеон', number: 14, type: 'Защитники'}, {
    name: 'Одои Денис',
    number: 3,
    type: 'Защитники'
  }, {name: 'Салису Мохамммед', number: 4, type: 'Защитники'}, {
    name: 'Сейду Алиду',
    number: 26,
    type: 'Защитники'
  }, {name: 'Suraj Seidu', number: 39, type: 'Полузащитники'}, {
    name: 'Абдул Самед Салис',
    number: 21,
    type: 'Полузащитники'
  }, {name: 'Кудус Мохаммед', number: 20, type: 'Полузащитники'}, {
    name: 'Кьере Даниэль-Кофи',
    number: 8,
    type: 'Полузащитники'
  }, {name: 'Овусу Элиша Овусу', number: 6, type: 'Полузащитники'}, {
    name: 'Парти Томас',
    number: 5,
    type: 'Полузащитники'
  }, {name: 'Сова Камаль', number: 24, type: 'Полузащитники'}, {
    name: 'Фатаву Иссахаку',
    number: 18,
    type: 'Полузащитники'
  }, {name: 'Айю Андре', number: 10, type: 'Нападающие'}, {
    name: 'Айю Джордан',
    number: 9,
    type: 'Нападающие'
  }, {name: 'Африйе Даниэль', number: 13, type: 'Нападающие'}, {
    name: 'Букари Осман',
    number: 11,
    type: 'Нападающие'
  }, {name: 'Семеньо Антуан', number: 11, type: 'Нападающие'}, {
    name: 'Сулемана Камалдин',
    number: 22,
    type: 'Нападающие'
  }, {name: 'Уильямс Иньяки', number: 19, type: 'Нападающие'}, {name: 'Аддо Отто', type: 'Тренер'}]
};
